'use es6';

import Loadable from 'UIComponents/decorators/Loadable';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = () => /*#__PURE__*/_jsx(UIFlex, {
  justify: "start",
  className: "relative",
  children: /*#__PURE__*/_jsx(UILoadingSpinner, {
    size: "xs"
  })
});
export function makeAsyncTitle({
  loader
}) {
  return Loadable({
    loader,
    LoadingComponent
  });
}